import React, { useRef, useEffect } from 'react';
import css from './dollarsAnimation.module.css';

import { gsap } from 'gsap';

import dollar from '../../img/dollar/dollar1.svg';

const DollarsAnimation = () => {
  const el1 = useRef();
  const el2 = useRef();
  const el3 = useRef();
  const el4 = useRef();
  const el5 = useRef();
  const el6 = useRef();
  const el7 = useRef();
  const el8 = useRef();
  const el9 = useRef();
  const el10 = useRef();
  const el11 = useRef();
  const el12 = useRef();
  const el13 = useRef();
  const el14 = useRef();
  const el15 = useRef();
  const el16 = useRef();
  const el17 = useRef();
  const el18 = useRef();
  const el19 = useRef();
  const el20 = useRef();
  const el21 = useRef();
  const el22 = useRef();
  const el23 = useRef();
  const el24 = useRef();
  const el25 = useRef();
  const el26 = useRef();
  const el27 = useRef();
  const el28 = useRef();
  const el29 = useRef();
  const el30 = useRef();
  const el31 = useRef();
  const el32 = useRef();
  const el33 = useRef();
  const el34 = useRef();
  const el35 = useRef();
  const el36 = useRef();
  const el37 = useRef();
  const el38 = useRef();
  const el39 = useRef();
  const el40 = useRef();
  const el41 = useRef();
  const el42 = useRef();
  const el43 = useRef();
  const el44 = useRef();
  const el45 = useRef();
  const el46 = useRef();
  const el47 = useRef();
  const el48 = useRef();
  const el49 = useRef();
  const el50 = useRef();
  const el51 = useRef();
  const el52 = useRef();
  const el53 = useRef();
  const el54 = useRef();
  const el55 = useRef();
  const el56 = useRef();
  const el57 = useRef();
  const el58 = useRef();
  const el59 = useRef();
  const el60 = useRef();
  const el61 = useRef();
  const el62 = useRef();
  const el63 = useRef();
  const el64 = useRef();
  const el65 = useRef();
  const el66 = useRef();
  const el67 = useRef();
  const el68 = useRef();

  useEffect(() => {
    // const arrayElements = [
    //   el1.current,
    //   el2.current,
    //   el3.current,
    //   el4.current,
    //   el5.current,
    //   el6.current,
    //   el7.current,
    //   el8.current,
    //   el9.current,
    //   el10.current,
    //   el11.current,
    //   el12.current,
    //   el13.current,
    //   el14.current,
    //   el15.current,
    //   el16.current,
    //   el17.current,
    //   el18.current,
    //   el19.current,
    //   el20.current,
    //   el21.current,
    //   el22.current,
    //   el23.current,
    //   el24.current,
    //   el25.current,
    //   el26.current,
    //   el27.current,
    //   el28.current,
    //   el29.current,
    //   el30.current,
    //   el31.current,
    //   el32.current,
    //   el33.current,
    //   el34.current,
    //   el35.current,
    //   el36.current,
    //   el37.current,
    //   el38.current,
    //   el39.current,
    //   el40.current,
    //   el41.current,
    //   el42.current,
    //   el43.current,
    //   el44.current,
    //   el45.current,
    //   el46.current,
    //   el47.current,
    //   el48.current,
    //   el49.current,
    //   el50.current,
    //   el51.current,
    //   el52.current,
    //   el53.current,
    //   el54.current,
    //   el55.current,
    //   el56.current,
    //   el57.current,
    //   el58.current,
    //   el59.current,
    //   el60.current,
    //   el61.current,
    //   el62.current,
    //   el63.current,
    //   el64.current,
    //   el65.current,
    //   el66.current,
    //   el67.current,
    //   el68.current,
    // ];
    const interval = 9;
    const transactionY = 1150;
    gsap.to(el1.current, {
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el2.current, {
      delay: 1,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el3.current, {
      delay: 1.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el4.current, {
      delay: 2,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el5.current, {
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el6.current, {
      delay: 1,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el7.current, {
      delay: 1.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el8.current, {
      delay: 2,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el9.current, {
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el10.current, {
      delay: 1,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el11.current, {
      delay: 1.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el12.current, {
      delay: 2,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el13.current, {
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el14.current, {
      delay: 1,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el15.current, {
      delay: 1.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el16.current, {
      delay: 2,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el17.current, {
      delay: 2.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el18.current, {
      delay: 3.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el19.current, {
      delay: 4,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el20.current, {
      delay: 4.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el21.current, {
      delay: 2.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el22.current, {
      delay: 3.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el23.current, {
      delay: 4,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el24.current, {
      delay: 4.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el25.current, {
      delay: 2.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el26.current, {
      delay: 3.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el27.current, {
      delay: 4,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el28.current, {
      delay: 4.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el29.current, {
      delay: 2.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el30.current, {
      delay: 3.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el31.current, {
      delay: 4,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el32.current, {
      delay: 4.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el33.current, {
      delay: 5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el34.current, {
      delay: 6,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el35.current, {
      delay: 6.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el36.current, {
      delay: 7,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el37.current, {
      delay: 5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el38.current, {
      delay: 6,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el39.current, {
      delay: 6.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el40.current, {
      delay: 7,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el41.current, {
      delay: 5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el42.current, {
      delay: 6,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el43.current, {
      delay: 6.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el44.current, {
      delay: 7,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el45.current, {
      delay: 5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el46.current, {
      delay: 6,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el47.current, {
      delay: 6.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el48.current, {
      delay: 7,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el49.current, {
      delay: 7.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el50.current, {
      delay: 8.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el51.current, {
      delay: 9,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el52.current, {
      delay: 9.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el53.current, {
      delay: 7.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el54.current, {
      delay: 8.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el55.current, {
      delay: 9,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el56.current, {
      delay: 9.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el57.current, {
      delay: 7.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el58.current, {
      delay: 8.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el59.current, {
      delay: 9,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el60.current, {
      delay: 9.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el61.current, {
      delay: 7.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '+=360',
    });
    gsap.to(el62.current, {
      delay: 8.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
    gsap.to(el63.current, {
      delay: 9,
      y: transactionY,
      repeat: -1,
      duration: interval,
      rotation: '-=360',
    });
    gsap.to(el64.current, {
      delay: 9.5,
      y: transactionY,
      repeat: -1,
      duration: interval,
    });
  });

  return (
    <div className={css.container_dollars}>
      <div className={css.block_dollars}>
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el1} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el2} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el3} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el4} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el5} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el6} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el7} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el8} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el9} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el10} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el11} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el12} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el13} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el14} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el15} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el16} />
      </div>
      <div className={css.block_dollars}>
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el17} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el18} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el19} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el20} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el21} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el22} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el23} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el24} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el25} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el26} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el27} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el28} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el29} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el30} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el31} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el32} />
      </div>
      <div className={css.block_dollars}>
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el33} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el34} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el35} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el36} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el37} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el38} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el39} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el40} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el41} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el42} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el43} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el44} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el45} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el46} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el47} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el48} />
      </div>
      <div className={css.block_dollars}>
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el49} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el50} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el51} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el52} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el53} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el54} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el55} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el56} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el57} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el58} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el59} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el60} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el61} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el62} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el63} />
        <img src={dollar} alt="dollar" className={css.dollar_svg} ref={el64} />
      </div>
    </div>
  );
};

export default DollarsAnimation;
